import { axios } from '@/utils/request'
/**
 * 商品收发明细表
 * @param parameter
 * @returns {*}
 */
export function excelStorageReportDetail (parameter) {
  return axios({
    url: '/excel/storage/reportdetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 销货单
 * @param parameter
 * @returns {*}
 */
export function excelSalesInvoiceDetail (parameter) {
  return axios({
    url: '/excel/sales/invoicedetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 采购单
 * @param parameter
 * @returns {*}
 */
export function excelPurchaseInvoiceDetail (parameter) {
  return axios({
    url: '/excel/purchase/invoicedetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 采购退货单
 * @param parameter
 * @returns {*}
 */
export function excelPurchaseRecedeDetail (parameter) {
  return axios({
    url: '/excel/purchase/recededetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 销货退货单
 * @param parameter
 * @returns {*}
 */
export function excelSalesRecedeDetail (parameter) {
  return axios({
    url: '/excel/sales/recededetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 采购订单
 * @param parameter
 * @returns {*}
 */
export function excelPurchaseBillDetail (parameter) {
  return axios({
    url: '/excel/purchase/billdetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 销售订单
 * @param parameter
 * @returns {*}
 */
export function excelSalesBillDetail (parameter) {
  return axios({
    url: '/excel/sales/billdetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 采购明细表
 * @param parameter
 * @returns {*}
 */
export function excelPurchaseReportEntries (parameter) {
  return axios({
    url: '/excel/purchase/reportentries',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 销售明细表
 * @param parameter
 * @returns {*}
 */
export function excelSalesReportEntries (parameter) {
  return axios({
    url: '/excel/sales/reportentries',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 采购汇总表（按商品）
 * @param parameter
 * @returns {*}
 */
export function excelPurchaseReportSummary (parameter) {
  return axios({
    url: '/excel/purchase/reportsummary',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 销售汇总表（按商品）
 * @param parameter
 * @returns {*}
 */
export function excelSalesReportSummary (parameter) {
  return axios({
    url: '/excel/sales/reportsummary',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 其他入库单详情
 * @param parameter
 * @returns {*}
 */
export function excelStorageInDetail (parameter) {
  return axios({
    url: '/excel/storage/indetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

/**
 * 其他出库单详情
 * @param parameter
 * @returns {*}
 */
export function excelStorageOutDetail (parameter) {
  return axios({
    url: '/excel/storage/outdetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}

export function excelPdReport (parameter) {
  return axios({
    url: '/excel/storage/pdreport',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}